import React from 'react';
import TareasTerminadas from '../../../../general/TareasTerminadas';
import emma_s1 from './../../../../../global/imagenes/emma_s1.png';

function MensajeSinPermiso({ mensaje = 'No tienes permisos para ver esta información.' }) {
    return (
        <TareasTerminadas
            mensaje={mensaje}
            marginTop='7%'
            imagen={emma_s1}
            widthImg="7%"
        />
    );
}

export default React.memo(MensajeSinPermiso);
